<template>
  <div>
    <b-form-group>
      <template #label>
        <span>
          {{ $t('Date Range') }}
        </span>
        <span v-if="showDateWithTitle">
          <span v-if="activeTab !== 4">
            ({{ FORMAT_DATE_RANGE(ranges[activeTab].dateRange.startTime, ranges[activeTab].dateRange.endTime) }})
          </span>
          <span v-else-if="form.start_date && form.end_date">
            ({{ FORMAT_DATE_RANGE(form.start_date, form.end_date) }})
          </span>
        </span>
      </template>
      <b-tabs
        v-model="activeTab"
        pills
        content-class="d-flex justify-content-end"
      >
        <b-tab
          v-for="(item,index) in ranges"
          :id="`${datePickerId}_${item.title}`"
          :key="index"
          lazy
          @click="item.title !== 'Custom' ? $emit('change',item.dateRange) : null"
        >
          <template #title>
            <span
              v-b-tooltip.top="IS_MOBILE() ? '' : item.description"
              class="font-weight-bold"
            >
              {{ item.title }}
            </span>
          </template>
        </b-tab>
      </b-tabs>
    </b-form-group>

    <date-range-picker
      :ref="datePickerId"
      :trigger-target="`${datePickerId}_Custom___BV_tab_button__`"
      :start-date="form.start_date"
      :end-date="form.end_date"
      @change="(({ startDate, endDate}) => {
        form.start_date = startDate
        form.end_date = endDate
        $emit('change', { startTime: startDate, endTime: endDate })
      })"
    />
  </div>
</template>
<script>
import { BTab, BTabs, BFormGroup } from 'bootstrap-vue'
import DateRangePicker from './DateRangePicker.vue'

const moment = require('moment')

export default {
  components: {
    BTab,
    BTabs,
    BFormGroup,
    DateRangePicker,
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    tillDayBefore: {
      type: Boolean,
      default: () => false,
    },
    datePickerId: {
      type: String,
      default: () => 'Custom',
    },
    showDateWithTitle: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      activeTab: 0,
      form: {
        start_date: null,
        end_date: null,
      },
      ranges: [
        {
          title: 'MTD',
          dateRange: this.tillDayBefore
            ? { startTime: moment(this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start).startOf('month').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() }
            : { startTime: moment(this.TODAY({ localTime: false })).startOf('month').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() },
          description: 'Month to Date',
        },
        {
          title: 'P3M',
          dateRange: this.tillDayBefore
            ? { startTime: moment(this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start).startOf('month').subtract(2, 'month').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() }
            : { startTime: moment(this.TODAY({ localTime: false })).startOf('month').subtract(2, 'month').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() },
          description: 'Past 3 months',
        },
        {
          title: 'P6M',
          dateRange: this.tillDayBefore
            ? { startTime: moment(this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start).startOf('month').subtract(5, 'month').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() }
            : { startTime: moment(this.TODAY({ localTime: false })).startOf('month').subtract(5, 'month').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() },
          description: 'Past 6 months',
        },
        {
          title: 'YTD',
          dateRange: this.tillDayBefore
            ? { startTime: moment(this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start).startOf('year').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() }
            : { startTime: moment(this.TODAY({ localTime: false })).startOf('year').format('YYYY-MM-DD HH:mm:ss'), endTime: this.maxDate() },
          description: 'Year to Date',
        },
        {
          title: 'Custom',
          dateRange: { startTime: null, endTime: null },
          description: 'Custom Date',
        },
      ],
    }
  },
  methods: {
    maxDate() {
      return this.tillDayBefore
        ? this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start
        : this.TODAY_COMPANY_TIME().start
    },
  },

}
</script>

<style>
@media screen and (max-width: 768px) {
  .nav-pills .nav-link {
    padding: 0.5rem 1rem;
    margin-bottom: 8px;
  }
}
</style>
